import { make } from 'vuex-pathify';
import initialState from './state';

export default {
    ...make.mutations(initialState),

    UPDATE_TABLE_COLUMN(state, { field, rowIndex, column, value }) {
        const sectionIndex = state.document.sections.findIndex(s => s.fields.find(f => f.id === field.id));

        const fieldIndex = state.document.sections[sectionIndex].fields.findIndex(f => f.id === field.id);

        const initialValue = state.document.sections[sectionIndex].fields[fieldIndex].value;

        initialValue[rowIndex][column] = value;

        state.document.sections[sectionIndex].fields[fieldIndex].value = initialValue;
    },
};
